import { IconDefinition, IconName, IconPrefix } from '@fortawesome/fontawesome-common-types';

export const tacs3AccidentIllness: IconDefinition = {
  prefix: 'tacs3' as IconPrefix,
  iconName: 'accident-illness' as IconName,
  icon: [
    16,
    16,
    [],
    '&#xe809;',
    'm 9.3 7.3 l -1.7 -1.3 v -0.9 h 0.6 c 0.3 0 0.5 -0.3 0.5 -0.6 v -2.4 c 0 -1.1 -0.7 -1.8 -1.8 -1.8 h -3.6 c -1.1 0 -1.8 0.7 -1.8 1.8 v 2.4 c 0 0.3 0.2 0.6 0.6 0.6 h 0.6 v 1 l -1.7 1.2 c -0.5 0.4 -0.8 0.9 -0.8 1.5 v 5.6 c 0 1.1 0.8 1.8 1.8 1.8 h 6.1 c 1.1 0 1.8 -0.7 1.8 -1.8 v -5.6 c 0.1 -0.6 -0.2 -1.1 -0.6 -1.5 l 0 0 z m -6.6 -5.2 c 0 -0.3 0.2 -0.6 0.6 -0.6 h 3.6 c 0.3 0 0.6 0.2 0.6 0.6 v 1.8 h -4.8 v -1.8 z m 4.9 9.7 h -1.6 v 1.8 c 0 0.5 -0.4 0.9 -0.9 0.9 s -0.9 -0.4 -0.9 -0.9 v -1.8 h -1.7 c -0.5 0 -0.9 -0.4 -0.9 -0.9 s 0.4 -0.9 0.9 -0.9 h 1.7 v -1.5 c 0 -0.5 0.4 -0.9 0.9 -0.9 s 0.9 0.4 0.9 0.9 v 1.7 h 1.8 c 0.5 0 0.9 0.4 0.9 0.9 c -0.1 0.5 -0.6 0.7 -1.1 0.7 z',
  ],
};
